import DesignTokens from '@tableau/design-tokens';
import { NavigationArrowLeftIcon } from '@tableau/icons/NavigationArrowLeftIcon';
import { ButtonType, ButtonWidget, Tooltip, TooltipPosition } from '@tableau/widgets';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { Messages } from '~src/codegen/Localize';
import { PageHeaderStyles } from '~src/spacesPlatform/components/layout/PageHeaderStyles';
import { applyColor } from '~src/style/ColorService';

import { backButtonTextStyle } from '../styles/SiteAuthenticationSettingsStyles';
import { DiscardChangesDialog } from './multipleIDPComponents/DiscardChangesDialog';

export interface AuthenticationBackButtonProps {
  displayDiscardChangesDialog: boolean;
  discardChangesDialogTitle: string;
}

export function AuthenticationBackButton(props: AuthenticationBackButtonProps) {
    const history = useHistory();
    const urls = siteUrlsSelector(getAppStore().getState());
    return <>
      <div>
        <Tooltip getContent={() => <span>{Messages.back()}</span>} position={TooltipPosition.BottomRightCorner} testId={'back-button-tooltip'}>
          <ButtonWidget
            buttonType={ButtonType.IconOutline}
            testId="back"
            onClick={() => { props.displayDiscardChangesDialog ? DiscardChangesDialog(props.discardChangesDialogTitle) : history.goBack(); }}
            style={PageHeaderStyles.BackButton}
            getContent={state => {
              const useActiveIcon: boolean = state.hover || state.active || state.focus;
              const iconColor = useActiveIcon
                ? applyColor(DesignTokens.color.font.default.default, '#333')
                : applyColor(DesignTokens.color.font.default.secondary, '#666');
              return <NavigationArrowLeftIcon size={18} color={iconColor} alt={Messages.back()} />;
            }} />
        </Tooltip>
      </div>
      {/* <a href={urls.settingsAuthenticationUrl()}>{Messages.siteAuthenticationBackToAuthentication()}</a> */}
      <button style={backButtonTextStyle} onClick={() => { props.displayDiscardChangesDialog ? DiscardChangesDialog(props.discardChangesDialogTitle) : history.goBack(); }}>{Messages.siteAuthenticationBackToAuthentication()}</button>
    </>;
}